/**
 * LostDevicesTable — communication lost (offline devices) table.
 */

import { Link } from 'react-router-dom';

const LostDevicesTable = ({ data, sortColumn, sortOrder, onSort }) => {
    const sortIcon = (col) => {
        if (sortColumn !== col) return null;
        return <span style={{ marginLeft: 4, fontSize: 10 }}>{sortOrder === 'asc' ? '▲' : '▼'}</span>;
    };

    const getDeviceLink = (row) => {
        const mfg = parseInt(row.manufacture_id, 10);
        if (mfg === 1) return `/profiles/inovonics/${row.device_id}`;
        if (mfg === 4) return `/profiles/palcare/${row.device_id}`;
        return null;
    };

    const renderResidents = (row) => {
        const residents = row.residents;
        if (!residents || !Array.isArray(residents) || residents.length === 0) return '—';
        return residents.map((r, i) => (
            <span key={i}>
                {r.resident_id ? (
                    <Link to={`/profiles/resident/${r.resident_id}`} className="ar-link">{r.resident_name || '—'}</Link>
                ) : (r.resident_name || '—')}
                {i < residents.length - 1 ? ', ' : ''}
            </span>
        ));
    };

    return (
        <div className="dp-table-wrap" style={{ overflowX: 'auto' }}>
            <table className="dp-table">
                <thead className="dp-thead">
                    <tr>
                        <th className="dp-th" style={{ cursor: 'pointer' }} onClick={() => onSort('last_active')}>Last Active{sortIcon('last_active')}</th>
                        <th className="dp-th" style={{ cursor: 'pointer' }} onClick={() => onSort('device_name')}>Name{sortIcon('device_name')}</th>
                        <th className="dp-th" style={{ cursor: 'pointer' }} onClick={() => onSort('descriptions')}>Description{sortIcon('descriptions')}</th>
                        <th className="dp-th" style={{ cursor: 'pointer' }} onClick={() => onSort('manufacture_uuid')}>Serial Number{sortIcon('manufacture_uuid')}</th>
                        <th className="dp-th">Residents</th>
                        <th className="dp-th" style={{ cursor: 'pointer' }} onClick={() => onSort('area_name')}>Area{sortIcon('area_name')}</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 ? (
                        <tr className="dp-tr">
                            <td className="dp-td" colSpan={6}>
                                <div className="na-empty">
                                    <div className="na-empty__icon">✓</div>
                                    <div className="na-empty__text">No devices with communication lost</div>
                                </div>
                            </td>
                        </tr>
                    ) : null}
                    {data.map((row, idx) => {
                        const link = getDeviceLink(row);
                        return (
                            <tr key={row.device_id || idx} className="dp-tr">
                                <td className="dp-td" style={{ whiteSpace: 'nowrap' }}>{row.last_active || '—'}</td>
                                <td className="dp-td">
                                    {link ? (
                                        <Link to={link} className="ar-link">{row.device_name || '—'}</Link>
                                    ) : (row.device_name || '—')}
                                </td>
                                <td className="dp-td">{row.descriptions || '—'}</td>
                                <td className="dp-td" style={{ fontFamily: 'monospace', fontSize: 'var(--font-size-xs)' }}>{row.manufacture_uuid || '—'}</td>
                                <td className="dp-td">{renderResidents(row)}</td>
                                <td className="dp-td">
                                    {row.area_id ? (
                                        <Link to={`/profiles/area/${row.area_id}`} className="ar-link">{row.area_name || '—'}</Link>
                                    ) : (row.area_name || '—')}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default LostDevicesTable;
